/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Konsultan_O1Inputs */

const en_mk_sol_konsultan_o1 = /** @type {(inputs: Mk_Sol_Konsultan_O1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Billable hours shift toward judgement instead of gathering`)
};

const id_mk_sol_konsultan_o1 = /** @type {(inputs: Mk_Sol_Konsultan_O1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jam yang bisa ditagihkan bergeser ke penilaian, bukan pengumpulan`)
};

/**
* | output |
* | --- |
* | "Billable hours shift toward judgement instead of gathering" |
*
* @param {Mk_Sol_Konsultan_O1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_konsultan_o1 = /** @type {((inputs?: Mk_Sol_Konsultan_O1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Konsultan_O1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_konsultan_o1(inputs)
	return en_mk_sol_konsultan_o1(inputs)
});